<template>
	<div class="open">
		<h3 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">馨康母婴套餐开通 </h3>
		
		<div class="tab qjc-c-primary qjc-fts-16">
			<span class="qjc-relative">套餐开通</span>
		</div>
		
		<el-form
			:model="openData"
			inline
			hide-required-asterisk
			:rules="rules"
			ref="openForm"
		>
			<h4 class="qjc-fts-16 qjc-c-dark">个人信息</h4>
			<div v-for="(item, index) in openData.mobile" :key="index">
				<el-form-item
					label="手机号"
					prop="mobile"
					label-width="0.64rem"
				>
					<el-input
						v-model="openData.mobile[index]"
						@input="mustNumber(index, 1)"
						placeholder="请输入手机号"
					></el-input>
				</el-form-item>
				<el-form-item
					label="手机号确认"
					prop="mobileConf"
					label-width="0.82rem"
				>
					<el-input
						v-model="openData.mobileConf[index]"
						@input="mustNumber(index, 2)"
						placeholder="请输入手机号"
					></el-input>
					<el-button @click="addMobile" class="add"></el-button>
					<el-button :disabled="index == 0" @click="removeMobile(index)" class="remove"></el-button>
				</el-form-item>
			</div>
			
			<el-form-item
				label="体检地点"
				prop="examplace"
				label-width="0.64rem"
				class="place"
			>
				<el-select v-model="openData.examplace">
					<el-option
						v-for="place in examplaceList"
						:key="place"
						:label="place"
						:value="place"
					></el-option>
				</el-select>
			</el-form-item>
			
			<h4 class="product qjc-fts-16 qjc-c-dark">产品组合</h4>
			<el-form-item
				prop="package"
			>
				<el-checkbox
					v-model="openData.package"
				>
					馨康母婴套餐
				</el-checkbox>
				<p class="qjc-texta-c">剩余次数：{{ times }}次</p>
			</el-form-item>
			
			<el-button @click="open" :loading="submiting" class="open-btn qjc-fts-16 qjc-c-fff">开通</el-button>
			
		</el-form>
		
	</div>
</template>

<script>
	import { isPhone } from "@/utils"
	import { getPackage, sbpOpen } from "@/utils/axios"
	
	export default{
		name: "muyingSbpOpen",
		data() {
			var mobileVerify = (rule, value, callback) => {
				if(value[0] == ''){
					callback(new Error('不能为空'));
				}else if(!isPhone(value[0])){
					callback(new Error('手机号格式不正确'));
				}else{
					callback();
				}
			}
			
			var mobileConfVerify = (rule, value, callback) => {
				if(value[0] == ''){
					callback(new Error('不能为空'));
				}else if(!isPhone(value[0])){
					callback(new Error('手机号格式不正确'));
				}else if(value[0] != this.openData.mobile[0]){
					callback(new Error('与手机号格式不一致'));
				}else{
					callback();
				}
			}
			
			var packageVerify = (rule, value, callback) => {
				if(value){
					callback();
				}else{
					callback(new Error('基础套餐必选'));
				}
			}
			
			return {
				examplaceList: ['安儒月子中心凯旋店', '安儒月子中心番禺店'],// 体检地点列表
				
				times: 0,// 套餐剩余次数
				
				openData: {
					mobile: [''],
					mobileConf: [''],
					examplace: '',
					package: true
				},
				
				rules: {
					mobile: [
						{ validator: mobileVerify }
					],
					mobileConf: [
						{ validator: mobileConfVerify, trigger: 'submit' }
					],
					examplace: [
						{ required: true, message: '体检地点必选', trigger: 'change' }
					],
					package: [
						{ validator: packageVerify, trigger: 'change' }
					]
				},
				
				submiting: false
			}
		},
		beforeCreate() {
			getPackage({from: 'my'}).then(res => {
				if(res.code == 200){
					let data = JSON.parse(window.atob(res.data))
					this.times = data.package.base.times;
				}else{
					this.$myAlert({
						type: 'fail',
						title: res.msg
					});
				}
			});
		},
		methods: {
			//新增手机号
			addMobile() {
				this.openData.mobile.push('');
				this.openData.mobileConf.push('');
			},
			
			//移除手机号
			removeMobile(index) {
				this.openData.mobile.splice(index, 1);
			},
			
			//开通
			open() {
				this.$refs.openForm.validate(isSuc => {
					if(isSuc){
						var isVerify = true;
						// 多手机号
						if(this.openData.mobile.length > 1){
							this.openData.mobile.forEach((item, index) => {
								if(item == ''){
									this.$myAlert({
										type: 'fail',
										content: '手机号存在空输入'
									});
									isVerify = false;
								}else if(!isPhone(item)){
									this.$myAlert({
										type: 'fail',
										content: '有手机号存在格式错误'
									});
									isVerify = false;
								}else if(item != this.openData.mobileConf[index]){
									this.$myAlert({
										type: 'fail',
										content: '手机号确认存在不一致'
									});
									isVerify = false;
								}
							})
						}
						
						if(isVerify){
							this.submiting = true;
							
							sbpOpen({
								mobile: this.openData.mobile,
								examplace: this.openData.examplace
							}).then(res => {
								this.submiting = false;
								
								if(res.code == 200){
									this.$myAlert({
										type: 'success',
										content: '开通成功',
										callback: () => {
											this.$router.push('/muyingHistory');
										}
									});
								}else{
									this.$myAlert({
										type: 'fail',
										content: res.msg
									});
								}
							});
						}
					}
				});
			},
			
			// 输入需为数字  index:下标   type:手机号(1)或手机号确认(2)
			mustNumber(index, type) {
				this.openData[type==1?'mobile':'mobileConf'][index] = this.openData[type==1?'mobile':'mobileConf'][index].replace(/\D/g, '');
	
			}
			
		}
	}
</script>

<style scoped>
	.el-form >>> .el-form-item__label{
		font-size: 0.14rem;
		color: #777F8F;
		padding-right: 0;
		line-height: 0.36rem;
		text-align-last: justify;
		padding-right: 0.04rem;
		white-space: nowrap;
	}
	.el-form >>> .el-form-item__content,
	.el-form >>> .el-input__icon{
		line-height: 0.36rem;
	}
	.el-form .el-input,
	.el-form >>> .el-input input{
		width: 4.38rem;
		height: 0.36rem;
		font-size: 0.14rem;
		color: #40444D;
	}
	.el-form >>> .el-button--default.is-disabled::before{
		background-color: #D5D8DE !important;
	}
	.el-form >>> .el-checkbox__label{
		font-size: 0.14rem;
		color: #40444D;
		font-weight: 500;
		padding-left: 0;
		line-height: 0.56rem;
	}
	.el-form >>> .el-checkbox__input{
		position: absolute;
		top: 0;
		left: 0;
	}
	.el-form >>> .el-checkbox__inner{
		border-radius: 0.06rem 0 0.06rem 0;
	}
	.el-form >>> .el-checkbox__input.is-checked .el-checkbox__inner{
		background-color: #6681FA;
		border-color: #6681FA;
	}
</style>
<style lang="scss" scoped>
	.open{
		.tab{
			font-weight: 600;
			margin: 0.32rem 0 0.24rem;
			border-bottom: 0.01rem solid #F0F4F5;
			
			span{
				display: inline-block;
				height: 0.35rem;
				line-height: 0.16rem;
				
				&::after{
					content: '';
					position: absolute;
					bottom: 0;
					left: 50%;
					width: 0.16rem;
					height: 0.04rem;
					border-radius: 0.02rem;
					background-color: #6681FA;
					transform: translateX(-50%);
				}
			}
		}
	
		.el-form{
			.el-form-item{
				margin: 0.16rem 0 0 0;
				
				&:nth-child(2n){
					margin-left: 0.32rem;
				}
				&.place{
					margin-left: 0;
				}
				
				.add,
				.remove{
					position: relative;
					width: 0.36rem;
					height: 0.36rem;
					line-height: 0.36rem;
					background-color: #fff;
					border-radius: 0.04rem;
					border: 0.01rem solid #D5D8DE;
					color: #6681FA;
					font-size: 0.24rem;
					vertical-align: middle;
				}
				.add::before,
				.add::after,
				.remove::before{
					position: absolute;
					content: '';
					top: 50%;
					left: 50%;
					width: 0.16rem;
					height: 0.01rem;
					background-color: #6681FA;
					transform: translate(-50%, -50%);
				}
				.add::after{
					transform: translate(-50%, -50%)rotateZ(90deg);
				}
				.add{
					margin-left: 0.1rem;
				}
				.el-button+.el-button{
					margin-left: 0.04rem;
				}
				
				.el-checkbox{
					position: relative;
					width: 5.02rem;
					background-color: #F0F4F7;
					border-radius: 0.12rem 0 0.12rem 0;
					text-align: center;
					
					&+p{
						font-size: 0.13rem;
						line-height: 0.13rem;
						margin-top: 0.06rem;
					}
				}
			}
			.product{
				margin-top: 0.48rem;
			}
			.open-btn{
				display: block;
				width: 2rem;
				height: 0.48rem;
				font-weight: 600;
				margin: 0.4rem auto 0;
			}
		}
	}
</style>
